import { Colors, Fonts } from '../../../shared/theme/';
import React from 'react';

export default {
  defaultContent: {
    backgroundColor: Colors.white,
    padding: 20,
  } as React.CSSProperties,
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '16px',
    height: '56px'
  } as React.CSSProperties,
  headerText: {
    fontSize: 24,
  } as React.CSSProperties,
  tableWrapper: {
    backgroundColor: Colors.white,
    padding: 20
  } as React.CSSProperties,
  searchBox: {
    padding: '14px 10px'
  },
  table: {
  },
  textTableContent: {
    ...Fonts.style.header,
    fontSize: Fonts.size.text14,
    color: Colors.lightPurple
  },
  promotionTextEN: {
    ...Fonts.style.textcontentKanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.lightPurple
  },
  starIcon: {
    color: '#9012F5'
  },
  gap8: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  }
};
